/**
 * Converts an array to a new tree-like array, objects are getting a new "children"-attribute
 * @param objects the array that of wich a tree-like copy should be created
 * @param parentAttribute the attribute name in wich the parent key is stored
 * @param identifier the attribute name that stores the identifier of an object
 * @returns a new tree-like array with new objects
 */
export function arrayToTree(objects, getParentKey, getIdentifier) {
    const map = new Map();
    const roots = [];
    objects.forEach((obj) => {
        map.set(getIdentifier(obj), obj);
    });
    objects.forEach((obj) => {
        var _a, _b;
        const parentKey = getParentKey(obj);
        const parent = parentKey ? map.get(parentKey) : undefined;
        if (parent) {
            (_b = (_a = parent.children) === null || _a === void 0 ? void 0 : _a.push(obj)) !== null && _b !== void 0 ? _b : (parent.children = [obj]);
        }
        else {
            roots.push(map.get(getIdentifier(obj)));
        }
    });
    return roots;
}
// EXAMPLE
// const arr = [
//   {
//     someAttributes: "",
//     weirdId: "hEHIec",
//     weirdParent: "12345",
//   },
//   {
//     someAttributes: "",
//     weirdId: "12345",
//     weirdParent: undefined,
//   },
// ];
// const newHierarchyArray = arrayToHierarchy(arr, obj => obj.weirdParent, obj => obj.weirdId);
/**
 * Converts any hierarchy-array to a flat array. Does not alter the array
 * @param objects the hierarchy array
 * @param getChildren a getter function to get the attribute where the children are stored
 * @returns a flat array containing all objects of the hierarchy array
 */
export function treeToArray(objects, getChildren) {
    const flattedObjects = [];
    objects.forEach((obj) => {
        flattedObjects.push(obj);
        const children = getChildren(obj);
        if (children && children.length > 0) {
            const nextChildren = treeToArray(children, getChildren);
            flattedObjects.push(...nextChildren);
        }
    });
    return flattedObjects;
}
// EXAMPLE (revert upper example)
// const flatArray = treeToArray(newHierarchyArray, (obj) => obj.children)
//# sourceMappingURL=arrayToTree.js.map